import { Box, Button, Card,  CardContent,  Grid, Paper, Typography } from '@material-ui/core'
import React, { useContext,  useMemo, useState } from 'react'
import UserContext from '../../context/Globales/UserContext';
import { Link, useHistory } from 'react-router-dom';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import MailIcon from '@material-ui/icons/Mail';
import { AuthContext } from '../../context/Globales/AuthContext';
import { types } from '../../context/types';
import Loading from '../modales/Loading';
import { DecodificanString } from '../../helpers/Codifican';


const MenuMobile = () => {
    const history = useHistory();

    const { user: { name } } = useContext(AuthContext);
    //const {user:{name}} = useContext(UserContext);
    const { dispatch } = useContext(AuthContext);

    const NombeUser = DecodificanString(JSON.parse(localStorage.getItem('name')));
    const ClienteId = DecodificanString(JSON.parse(localStorage.getItem('clientId')));
    const ContractId = DecodificanString(JSON.parse(localStorage.getItem('contractId')));
    const { DataPermisos, DataTipoContracto } = useContext(UserContext);
    const [OpenLoading, setOpenLoading] = useState(false);
    const datosPermisosMenu = JSON.parse(localStorage.getItem('datosPermisos'));
    const userContext = useContext(UserContext);

    useMemo(() => {
        userContext.getTipoContracto(ClienteId, ContractId);
      }, []);


    const handleLogoutMobile = (e) => {
        setOpenLoading(true);
        localStorage.clear();
          dispatch({type: types.AuthLogout})
           // window.location.href=parametros.rutaServidor +"login";
        setOpenLoading(false)
      };

    return (
        <div>
            <Box display="flex-end" justifycontent="center" my={15} spacing={2} >
                    <Grid item xs={12} sm={12} md={12} xl={12} lg={12} >
                        <Card>
                        <CardContent>
                                <Typography  color="primary" variant="h6"> <Typography color="textSecondary"  > Conectado(a) como:  </Typography> {NombeUser} <br />
                                    <Box my={1} spacing={2}>
                                        <Button onClick={handleLogoutMobile} variant="outlined" color="secondary" size="small" > Cerrar Sesion </Button>
                                    </Box>
                                    </Typography>

                    </CardContent>
                        </Card>
                    </Grid>
                    <br />
                    {DataTipoContracto && DataTipoContracto.IsPrepago ?
                        <Grid item xs={12} sm={12} md={12} xl={12} lg={12} >
                            <Card>
                                <CardContent>
                                    Tú Plan Actual: <br /> <p style={{ fontSize: '9px' }} >{DataTipoContracto.Nombre}</p> &nbsp;
                                    <Button variant="outlined" color="primary" onClick={() => history.push("/viewsaldo")} >Ver Saldo</Button>
                                </CardContent>
                            </Card>
                        </Grid>
                        : ''}
                    <br />
                    <Grid container
                        direction="row"
                        justifycontent="flex-start"
                        alignItems="center" spacing={2}  >
                        {datosPermisosMenu?.map((itemm) => (
                            itemm.details.map((itemss) => (
                                <Grid item xs={6} sm={6} md={6} xl={6} lg={6} style={{ textAlign: 'center', textDecoration: 'none' }} key={itemss.name} >
                                    {itemss.name != 'Informe Comercial Multiples Rut' ?
                                    <Link to={itemss.url} >
                                            <Card >
                                                <CardContent >
                                                    {itemss.name == 'Informes Comerciales' ? <>  <LibraryBooksIcon /> <br /> Informes Comerciales   </> : ''}
                                                    {itemss.name == 'Soporte' ? <> <MailIcon /> <br /> Soporte </> : ''}
                                                    {itemss.name == 'Verificacion Cheque y ONP' ? <> <CheckCircleIcon /> <br /> Verificacion Cheque y ONP </> : ''}
                                                    {itemss.name == 'Registro de Acceso' ? <> <SupervisorAccountIcon /> <br /> Registro de Acceso </> : ''}
                                                </CardContent>

                                            </Card>
                                        </Link>
                                        : ''}
                                </Grid>
                            ))
                        ))}
                    </Grid>
            </Box>
            {OpenLoading ? <Loading  /> : null }
        </div>
    )
}

export default MenuMobile
